import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routers";
import RouterMaster from "./RouterMaster";

const generateTitle = (title, hideSuffix = false) => {
  console.log(title);
  let _ = '青海省法规规章规范性文件数据库';
  if (hideSuffix) return title || _;

  if (title) _ = `${title} · ${_}`;
  return _;
};

// 解决路由重复问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  document.title = generateTitle(to.matched[to.matched.length - 1].meta.title);
});

export default router;

export const routerMaster = new RouterMaster(router);